export default {
  "nl": {
    "form": {
      "actions": {
        "cancel": "Annuleren",
        "saveChanges": "Sla veranderingen op"
      },
      "back": "Vorige stap",
      "password": "Wachtwoord",
      "steps": "Stap {count} van {total}",
      "writeEmployeeNameReject": "Schrijf <i><b>{employeeName}</b></i> neer om het verwijderen te bevestigen."
    }
  }
}